import React, { useState, useEffect, useRef, forwardRef } from "react";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
class ThuChiHopDongPrint extends React.Component {
  renderTableData() {
    if (typeof this.props.dataPrint.List != "undefined") {
      return this.props.dataPrint.List.map((item, i) => {
        return (
          <tr>
            <td style={{ border: "1px solid #EEE", textAlign: "center" }}>
              <div>{i + 1}</div>
            </td>
            <td style={{ border: "1px solid #EEE", textAlign: "left" }}>
              {getDate(item.Time)}
            </td>
            <td style={{ border: "1px solid #EEE" }}>{item.userFullName}</td>
            <td style={{ border: "1px solid #EEE" }}>{item.Code}</td>
            <td style={{ border: "1px solid #EEE" }}>{item.nameCus}</td>
            <td style={{ border: "1px solid #EEE" }}>{item.Cmt}</td>
            <td style={{ border: "1px solid #EEE" }}>
              {item.Type == 2 && <span>Chi cho vay</span>}
              {item.Type == 45 && <span>Thanh lý tất toán HĐ</span>}
              {item.Type == 23 && <span>Chi đảo họ</span>}
              {item.Type == 1 && <span>Kỳ lãi</span>}
              {item.Type == 15 && <span>Phí cho vay</span>}
              {item.Type == 4 && <span>Thu nhận vay</span>}
              {item.Type == 18 && <span>Thu trả bớt gốc nhận vay</span>}
              {item.Type == 13 && <span>Tất toán nhận vay</span>}
              {item.Type == 11 && <span>Tất toán</span>}
              {item.Type == 3 && <span>Lãi nhận vay</span>}
              {item.Type == 12 && <span>Thu phí phát sinh</span>}
              {item.Type == 9 && <span>Thu phí</span>}
              {item.Type == 17 && <span>Trả bớt gốc</span>}
              {item.Type == 16 && <span>Thanh lý tài sản</span>}
              {item.Type == 21 && <span>Vay thêm</span>}
              {item.Type == 17 && <span>Trả bớt gốc</span>}
              {item.Type == 22 && <span>Thu họ cắt lãi trước</span>}
              {item.Type == 24 && <span>Thu phí khác{/* {item.Note}*/}</span>}
              {item.Type == 25 && <span>Lãi quá hạn</span>}
            </td>
            <td style={{ border: "1px solid #EEE", textAlign: "right" }}>
              {item.Value >= 0 && formatNumber(item.Value)}
              {item.Value < 0 && <span>0</span>}
            </td>
            <td style={{ border: "1px solid #EEE", textAlign: "right" }}>
              {item.Value <= 0 && formatNumber(-1 * item.Value)}
              {item.Value > 0 && <span>0</span>}
            </td>
            {this.props.dataPrint.ConfigPhiKho === 1 && (
              <td style={{ border: "1px solid #EEE", textAlign: "right" }}>
                {formatNumber(item.PhiKho)}
              </td>
            )}
            <td style={{ border: "1px solid #EEE", textAlign: "right" }}>
              {formatNumber(item.OtherFee)}
            </td>
            {this.props.dataPrint.ConfigHoaHong === 1 && (
              <>
                <td
                  style={{
                    border: "1px solid #EEE",
                    textAlign: "right",
                  }}
                >
                  {formatNumber(item.Amercement)}
                </td>
                <td
                  style={{
                    border: "1px solid #EEE",
                    textAlign: "right",
                  }}
                >
                  {formatNumber(-1 * item.PhiHoaHongTraGop)}
                </td>
              </>
            )}
            <td style={{ border: "1px solid #EEE", textAlign: "right" }}>
              {formatNumber(item.PhiPhatDongLai)}
            </td>
            <td style={{ border: "1px solid #EEE", textAlign: "right" }}>
              {formatNumber(item.PhiPhatTatToan)}
            </td>
            <td style={{ border: "1px solid #EEE", textAlign: "right" }}>
              {formatNumber(item.ValueGoc)}
            </td>
            <td style={{ border: "1px solid #EEE", textAlign: "right" }}>
              {formatNumber(item.ValueLai)}
            </td>
            <td style={{ border: "1px solid #EEE", textAlign: "right" }}>
              {formatNumber(item.OtheFeeHangKy)}
            </td>
          </tr>
        );
      });
    }
  }

  render() {
    console.log(this.props.dataPrint, "this.props.dataPrint");
    return (
      <>
        <div id={this.props.dataPrint.TypeName}>
          <table style={{ width: "90%", margin: "0 auto" }}>
            <tr>
              <td
                style={{
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                  fontSize: "18px",
                  color: "#000000",
                }}
                colSpan={13}
              >
                <br />
                DANH SÁCH THU/CHI HỢP ĐỒNG
              </td>
            </tr>
            <tr>
              <td
                style={{
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                  fontSize: "14px",
                  color: "#000000",
                }}
                colSpan={13}
              >
                Từ ngày: {this.props.dataPrint.TuNgay} - Đến ngày:{" "}
                {this.props.dataPrint.DenNgay}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  textAlign: "left",
                  width: "100%",
                  fontWeight: "bold",
                  fontSize: "14px",
                  color: "#000000",
                }}
                colSpan={13}
              >
                {this.props.dataPrint.TongTienThuBangChu}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  textAlign: "left",
                  width: "100%",
                  fontWeight: "bold",
                  fontSize: "14px",
                  color: "#000000",
                }}
                colSpan={13}
              >
                {this.props.dataPrint.TongTienChiBangChu}
              </td>
            </tr>
          </table>
          <table
            style={{
              border: "1px solid #EEE",
              width: "100%",
              color: "#000000",
              marginTop: "10px",
            }}
          >
            <tr>
              <th
                style={{ border: "1px solid #EEE", textAlign: "center" }}
                rowSpan={2}
              >
                <div>STT</div>
                <span>[ {this.props.dataPrint.TongBanGhi} ]</span>
              </th>
              <th style={{ border: "1px solid #EEE" }} rowSpan={2}>
                <div>Ngày giao dịch</div>
              </th>
              <th style={{ border: "1px solid #EEE" }} rowSpan={2}>
                Nhân viên
              </th>
              <th style={{ border: "1px solid #EEE" }} rowSpan={2}>
                Mã hợp đồng
              </th>
              <th style={{ border: "1px solid #EEE" }} rowSpan={2}>
                Tên khách hàng
              </th>
              <th style={{ border: "1px solid #EEE" }} rowSpan={2}>
                CMND
              </th>
              <th style={{ border: "1px solid #EEE" }} rowSpan={2}>
                Loại phiếu
              </th>
              <th
                style={{ border: "1px solid #EEE", textAlign: "right" }}
                rowSpan={2}
              >
                <div>Thu</div>
                <span>{this.props.dataPrint.TongThu}</span>
              </th>
              <th
                style={{ border: "1px solid #EEE", textAlign: "right" }}
                rowSpan={2}
              >
                <div>Chi</div>
                <span>{this.props.dataPrint.TongChi}</span>
              </th>
              {this.props.dataPrint.ConfigPhiKho === 1 && (
                <th
                  style={{ border: "1px solid #EEE", textAlign: "right" }}
                  rowSpan={2}
                >
                  <div>Phí kho</div>
                  <span>{this.props.dataPrint.TongPhiKho}</span>
                </th>
              )}
              <th
                style={{ border: "1px solid #EEE", textAlign: "right" }}
                rowSpan={2}
              >
                <div>Phí khác</div>
                <span>{this.props.dataPrint.TongPhiKhac}</span>
              </th>
              {this.props.dataPrint.ConfigHoaHong === 1 && (
                <>
                  <th
                    style={{ border: "1px solid #EEE", textAlign: "right" }}
                    rowSpan={2}
                  >
                    <div>Phí phạt</div>
                    <span>{this.props.dataPrint.TongPhiPhat}</span>
                  </th>
                  <th
                    style={{ border: "1px solid #EEE", textAlign: "right" }}
                    rowSpan={2}
                  >
                    <div>Phí hoa hồng</div>
                    <span>{this.props.dataPrint.TongPhiHoaHong}</span>
                  </th>
                </>
              )}
              <th
                style={{ border: "1px solid #EEE", textAlign: "right" }}
                rowSpan={2}
              >
                <div>Phạt chậm đóng lãi</div>
                <span>{this.props.dataPrint.TotalPhiPhatDongLai}</span>
              </th>
              <th
                style={{ border: "1px solid #EEE", textAlign: "right" }}
                rowSpan={2}
              >
                <div>Phạt tất toán sớm</div>
                <span>{this.props.dataPrint.TotalPhiPhatTatToan}</span>
              </th>
              <th
                style={{ border: "1px solid #EEE", textAlign: "center" }}
                colSpan={3}
              >
                <div>Thu lãi</div>
              </th>
            </tr>
            <tr>
              <th style={{ border: "1px solid #EEE", textAlign: "right" }}>
                <div>Tiền gốc</div>
                <span>{this.props.dataPrint.TotalValueGoc}</span>
              </th>
              <th style={{ border: "1px solid #EEE", textAlign: "right" }}>
                <div>Tiền lãi</div>
                <span>{this.props.dataPrint.TotalValueLai}</span>
              </th>
              <th style={{ border: "1px solid #EEE", textAlign: "right" }}>
                <div>Các loại phí</div>
                <span>{this.props.dataPrint.TotalOtheFeeHangKy}</span>
              </th>
            </tr>
            {this.renderTableData()}
          </table>
        </div>
      </>
    );
  }
}
export default ThuChiHopDongPrint;
